"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
exports.__esModule = true;
exports.getCustomCouponProductCartItem = exports.disableContinueBtn = exports.getCartFreeGiftIds = exports.getCartItemsIdByType = exports.getCartTotal = exports.reverseObj = exports.isCheckoutPage = void 0;
var config_1 = require("../config/config");
function isCheckoutPage() {
    return window.location.href.includes('checkouts');
}
exports.isCheckoutPage = isCheckoutPage;
function reverseObj(object) {
    var NewObj = {}, keysArr = Object.keys(object);
    for (var i = keysArr.length - 1; i >= 0; i--) {
        NewObj[keysArr[i]] = object[keysArr[i]];
    }
    return NewObj;
}
exports.reverseObj = reverseObj;
function getCartTotal(cart) {
    this.selectors = {
        checkoutDiscountAmountTargetAttr: 'checkout-discount-amount-target',
        checkoutDiscountAmountTarget: '[data-checkout-discount-amount-target]',
        checkoutTotalTaxesTargetAttr: 'checkout-total-taxes-target',
        checkoutTotalTaxesTarget: '[data-checkout-total-taxes-target]'
    };
    var cartTotal = cart.total_price / 100;
    if (isCheckoutPage()) {
        var $discountAmount = $(this.selectors.checkoutDiscountAmountTarget);
        if ($discountAmount.length) {
            //@ts-ignore
            var discountValue = parseInt($discountAmount.data(this.selectors.checkoutDiscountAmountTargetAttr)) / 100;
            cartTotal -= discountValue;
        }
    }
    return cartTotal;
}
exports.getCartTotal = getCartTotal;
function getCartItemsIdByType(cart, type) {
    return cart.items
        .map(function (item) { return item.product_type === type ? item.id.toString() : ''; })
        .filter(function (id) { return (id !== ''); });
}
exports.getCartItemsIdByType = getCartItemsIdByType;
function getCartFreeGiftIds(cart) {
    var cartSampleIds = getCartItemsIdByType(cart, 'Sample');
    var cartGwpIds = getCartItemsIdByType(cart, 'GWP');
    var customCouponItem = getCustomCouponProductCartItem();
    if (customCouponItem) {
        if (customCouponItem.properties._custom_coupon.options.isGwpAllowed) {
            cartGwpIds = cartGwpIds.filter(function (e) { return e.toString() !== customCouponItem.id.toString(); });
        }
    }
    return __spreadArrays(cartSampleIds, cartGwpIds);
}
exports.getCartFreeGiftIds = getCartFreeGiftIds;
function disableContinueBtn(value) {
    $(window[config_1["default"].storeKey].selectors.continueBtn).prop('disabled', value);
}
exports.disableContinueBtn = disableContinueBtn;
function getCustomCouponProductCartItem() {
    for (var _i = 0, _a = window[config_1["default"].storeKey].cart.items; _i < _a.length; _i++) {
        var cartItem = _a[_i];
        if (!cartItem.properties) {
            continue;
        }
        var itemProperties = cartItem.properties;
        if (!itemProperties._custom_coupon) {
            continue;
        }
        //@ts-ignore
        if (itemProperties._custom_coupon) {
            return cartItem;
        }
    }
    return null;
}
exports.getCustomCouponProductCartItem = getCustomCouponProductCartItem;
